export const CURRENT_CONTRACTS_QUERY = 'currentContractsQuery';